module.exports = __webpack_public_path__ + "img/browser_edge.d487a6f4.svg";